export class PricePlan {
	id: number;

	listingFeeNet: number;
	bookingFeeNet: number;
	verificationFeeNet: number;
	supportFeeNet: number;
	taxPercentage: number;
	minBillableListings: number;
	minMonthlyListingFee: number;

	startDate: Date;
	endDate: Date;

	pricePlanChargedByTypeId: PricePlanChargedByType;
}

export enum PricePlanChargedByType {
	'All' = 1,
	'VerificationStartDate',
	'CheckInDate',
}
